<template>
  <div>
    <v-btn small color="blue-grey" class="ma-2 white--text" fab>
      <v-icon dark> mdi-plus-circle-outline </v-icon>
    </v-btn>
    <template v-if="detailsEtapes.length > 0">
      <template>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-for="(item, index) in detailsEtapes" :key="index">
                <td>{{ item.ll_details_etapes }}</td>
                <td>
                  <v-btn outlined x-small fab dark class="warning mr-2">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn outlined x-small fab dark class="danger mr-2">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </template>

    <div v-else>
      Pas de Détails
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getDetailsEtape(this.etape.id);
  },
  props: {
    etape: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      detailsEtapes: [],
    };
  },
  methods: {
    getDetailsEtape(etapeId) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("detailEtapes")
        .where("etape_id_etape", "==", etapeId.toString())
        .orderBy("rangDetailEtape")
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.detailsEtapes.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = self.detailsEtapes.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
